import { render, staticRenderFns } from "./ProgramRoot.vue?vue&type=template&id=69204e52&"
import script from "./ProgramRoot.vue?vue&type=script&lang=js&"
export * from "./ProgramRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports